import { z } from "zod/v4";
import { clubCourtSchema, clubLocationSchema } from "../schemas/club-location";
import { fetchApi, fetchVoid } from "./internal";

export const clubLocations = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/locations`, z.array(clubLocationSchema)),
	create: (
		clubId: string,
		data: {
			name: string;
			address?: string | null;
			latitude?: number | null;
			longitude?: number | null;
			sort_order?: number;
		},
	) =>
		fetchApi(`/clubs/${clubId}/locations`, clubLocationSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (
		clubId: string,
		locationId: string,
		data: {
			name?: string;
			address?: string | null;
			latitude?: number | null;
			longitude?: number | null;
			sort_order?: number;
		},
	) =>
		fetchApi(`/clubs/${clubId}/locations/${locationId}`, clubLocationSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, locationId: string) =>
		fetchVoid(`/clubs/${clubId}/locations/${locationId}`, {
			method: "DELETE",
		}),
};

export const clubCourts = {
	list: (clubId: string, locationId: string) =>
		fetchApi(`/clubs/${clubId}/locations/${locationId}/courts`, z.array(clubCourtSchema)),
	create: (clubId: string, locationId: string, data: { name: string; sort_order?: number }) =>
		fetchApi(`/clubs/${clubId}/locations/${locationId}/courts`, clubCourtSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (
		clubId: string,
		locationId: string,
		courtId: string,
		data: { name?: string; sort_order?: number },
	) =>
		fetchApi(`/clubs/${clubId}/locations/${locationId}/courts/${courtId}`, clubCourtSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, locationId: string, courtId: string) =>
		fetchVoid(`/clubs/${clubId}/locations/${locationId}/courts/${courtId}`, {
			method: "DELETE",
		}),
};
